export const BASE_URL_SERVICE = "https://agrocrm.agrorecomenda.com/api/v1/";
